import { Input } from 'entities/Input'
import { useEffect, useState } from 'react'
import { useBranchStore } from 'shared/store/branchesSlice'

export const Mail = () => {
  const { branchList, branchId, updateBranch } = useBranchStore()
  const [mail, setMail] = useState<string>('')

  useEffect(() => {
    if (branchId && branchList?.length) {
      setMail(branchList?.find(branch => branch.Intern === branchId)?.Mail || '')
    }
  }, [branchList?.length, branchId])

  const updateMail = () => {
    if (branchList?.find(branch => branch.Intern === branchId)?.Mail !== mail) {
      updateBranch({ Mail: mail })
    }
  }

  return <Input label='Mail' onChange={setMail} onBlur={updateMail} value={mail} />
}
